import { render, staticRenderFns } from "./ChallengeItem.vue?vue&type=template&id=4e7c79ba&scoped=true&"
import script from "./ChallengeItem.vue?vue&type=script&lang=js&"
export * from "./ChallengeItem.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeItem.vue?vue&type=style&index=0&id=4e7c79ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c79ba",
  null
  
)

/* custom blocks */
import block0 from "./ChallengeItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports